import { BaseTextMergeElement } from "../BaseTextMergeElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";

export class LineBreakElement extends BaseTextMergeElement {
    readonly __type = "linebreak";
    readonly name = "Line Break";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 4;

    output(_data: ExecutionData, _config: TextMergeConfiguration, _textContext: ITestingContext | undefined): string {
        return "<br/>";
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.HTML || config.type === TextMergeType.MULTI_LINE;
    }
}
